import React from 'react';
import styles from './styles.css';

const SectionHeading = ({ text, children }) => (
  <>
    <h4>
      {text}
      {children}
    </h4>
    <style jsx>{styles}</style>
  </>
);

SectionHeading.defaultProps = {
  text: ''
};

export default SectionHeading;
